import React from 'react';
import PropTypes from 'prop-types';

const Modal = ({
  children, size, onClose, text, color,
}) => (
  <div className="modal-container">
    <div className={`modal-content ${size}`}>
      <div
        onClick={() => onClose()}
        className="modal-content_close"
      >
        <span>{text}</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11" stroke={color} strokeWidth="2" />
          <path d="M15.5287 9.53016L14.4712 8.47266L11.9999 10.9402L9.52869 8.47266L8.47119 9.53016L10.9387 12.0014L8.47119 14.4727L9.52869 15.5302L11.9999 13.0627L14.4712 15.5302L15.5287 14.4727L13.0612 12.0014L15.5287 9.53016Z" fill={color} />
        </svg>
      </div>
      {children}
    </div>
  </div>
);

Modal.defaultProps = {
  size: 'small',
  text: '',
  color: '#7981B2',
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
  text: PropTypes.string,
  color: PropTypes.string,
};

export default Modal;
